import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { roofingSystemPages } from "@/data/roofingSystemContent";

const c = roofingSystemPages["modified-bitumen-roofing"];

export const Route = createFileRoute("/services/modified-bitumen-roofing")({
  head: () => ({
    meta: [
      { title: "Modified Bitumen Roofing Southern California | McKay Roofing & Solar" },
      { name: "description", content: c.heroSubtitle },
      { property: "og:title", content: "Modified Bitumen Roofing - McKay Roofing & Solar" },
      { property: "og:description", content: c.heroSubtitle },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/modified-bitumen-roofing" }],
  }),
  component: () => <RoofingServicePage {...c} />,
});
